import React from 'react';
import { Link } from 'react-router-dom';

const roomData = [
  {
    title: '2 BHK Villa',
    // image: '/images/galleryy/20.jpg',
    image: '/images/homegallery/5.jpg',
    link: '',
    colSize: 'col-lg-4'
  },
  {
    title: 'Living Room',
    image: '/images/homegallery/2.jpg',
    // image: '/images/galleryy/2.jpg',
    link: '',
    colSize: 'col-lg-4'
  },
  {
    title: 'Dining Area',
    image: '/images/homegallery/6.jpg',
    // image: '/images/galleryy/3.jpg',
    link: '',
    colSize: 'col-lg-4'
  },
  // {
  //   title: 'Family Forest Suite',
  //   image: '/images/galleryy/4.jpg',
  //   link: '',
  //   colSize: 'col-lg-4'
  // },
  {
    title: 'View From the Villa',
    image: '/images/homegallery/1.jpg',
    link: '',
    colSize: 'col-lg-4'
  },
  {
    title: ' Bedroom',
    image: '/images/homegallery/9.jpg',
    // image: '/images/galleryy/6.jpg',
    link: '',
    colSize: 'col-lg-4'
  },
   {
    title: ' Machan',
    image: '/images/gallery/18.jpg',
    // image: '/images/galleryy/6.jpg',
    link: '',
    colSize: 'col-lg-4'
  }
];


const RoomsSection = () => {
  return (
    <section className="room-section">
      <div className="auto-container">
        {/* Header */}
        <div className="top-content">
          <div className="title-box text-light">
            <div className="sub-title">accommodation</div>
            <h2 className="sec-title">Rooms & Villas</h2>
          </div>
          <div className="right-column">
            <div className="text">
              Discover peace and adventure in the heart of nature. <br />
              Choose from our elegant cottages, family suites, and luxury 2 BHK villas.
            </div>
            <div className="link-btn">
            
            </div>
          </div>
        </div>

        {/* Rooms */}
        <div className="row">
          {roomData.map((room, index) => (
            <div key={index} className={`${room.colSize} room-block`}>
              <div className="inner-box">
                <div className="image">
                  <img src={room.image} alt={room.title} />
                </div>
                <div className="content">
                  <h3>
                    <Link to={room.link}>{room.title}</Link>
                  </h3>
                  {/* <div className="text-two">{room.price}</div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoomsSection;
